export enum PetProtectionBenefitType {
  VET_FEES = "Vet Fees",
  DENTAL = "Dental",
  THIRD_PARTY_LIABILITY = "Third Party Liability",
  BOARDING = "Boarding",
}
